import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbIconConfig, NbPositionValues, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from 'src/app/@core';
import { NotificationsApiService } from 'src/app/@core/api/notification-api.service';
import { Notification } from 'src/app/@core/domain/interfaces/notifications.interface';
import { StatusPageService } from 'src/app/pages/status-page/services/status-page.service';

@Component({
  selector: 'app-notification-actions',
  templateUrl: './notification-actions.component.html',
  styleUrls: ['./notification-actions.component.scss'],
})
export class NotificationActionsComponent implements OnInit {
  icon!: any;
  index!: number;
  dialogOpen = false;
  notificationHandled = false;
  direction: NbPositionValues = 'left';
  successMessage!: string;
  errorMessage!: string;

  @Input()
  notification!: Notification;

  @ViewChild('popoverTemplateRef', { read: TemplateRef }) popoverTemplateRef!: TemplateRef<any>;

  constructor(
    private notificationsApiService: NotificationsApiService,
    private translate: TranslateService,
    private statusPageService: StatusPageService,
    private toastrService: NbToastrService,
    private logger: LogService
  ) {}

  ngOnInit(): void {
    if (this.notification && this.notification.terminal && this.notification.terminal.type) {
      // this.icon = 'terminalType_' + this.notification.terminal.type['id'];
    }
    this.translate.get('NOTIFICATIONS.SUCCESS').subscribe((res: string) => {
      this.successMessage = res;
    });
    this.translate.get('NOTIFICATIONS.ERROR').subscribe((res: string) => {
      this.errorMessage = res;
    });
    this.dialogOpen = false;
  }

  open(): void {
    this.dialogOpen = !this.dialogOpen;
    if (this.dialogOpen) {
      //this.statusPageService.triggerPreventClick(true);
      this.statusPageService.triggerRefreshNotifications(false);
    } else {
      this.statusPageService.triggerRefreshNotifications(true);
    }
  }

  getIconType(notification: any): string {
    if (notification && notification.terminal) {
      const terminalTypeEnumValue = Object.values(notification.terminal.type)[0];
      return 'terminalType_' + terminalTypeEnumValue;
    }
    return 'terminalType_0';
  }

  close(): void {
    this.statusPageService.triggerRefreshNotifications(true);
    this.dialogOpen = false;
  }

  handleNotificationAction(id: string, type: number): void {
    this.notificationHandled = true;
    this.close();
    this.notificationsApiService.sendNotificationsAction(id, type).subscribe((result) => {
      if (result.success) {
        this.statusPageService.triggerRefreshNotifications(true);
        this.logger.info('Notification action type' + type + ' performed on notification ' + id);
        const iconConfig: NbIconConfig = { icon: 'checkmark-outline', pack: 'eva' };
        this.showToast(result.message, this.successMessage, {
          status: 'success',
          hasIcon: true,
          icon: iconConfig,
          duration: 5000,
          destroyByClick: true,
        });
      } else {
        this.logger.info(
          'Error performing notification action type' + type + ' on notification ' + id
        );
        const iconConfig: NbIconConfig = { icon: 'alert-triangle-outline', pack: 'eva' };
        this.showToast(result.message, this.errorMessage, {
          status: 'danger',
          hasIcon: true,
          icon: iconConfig,
          duration: 5000,
          destroyByClick: true,
        });
      }
    });
  }

  private showToast(message: string, title: string, config: any): void {
    this.index += 1;
    this.toastrService.show(message, title, config);
  }
}
